import React, { useState } from 'react';
import LoginForm from '../../components/LoginForm/LoginForm';
import { useNavigate } from 'react-router-dom';


const LoginPage = () => {
    const [error, setError] = useState('');
    const navigate = useNavigate(); 

    const handleSubmit = async (e) => {
        e.preventDefault();

        const login = e.target.login.value;
        const password = e.target.password.value;

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/login`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                login: login,
                passwd: password
            })
        });
        if (response.ok) {
            navigate('/');
        } else {
            setError(await response.text());
        }
    }
    
    return (
        <LoginForm handleSubmit={handleSubmit} error={error} /> 
    );
};

export default LoginPage;
